export default "__VITE_ASSET__CRZzE0St__"